export const AppConfig = {
    showFooter: false,
    repeatGuide: false,
    preOrderCard: false,
    showReleaseNotes: false,
    showDomainInstruction: false,
    showNftBlock: false,
    tawkPlagin: false,
    title: 'GEME Wallet',
    titleSecondary: 'GEME Wallet',
    mainColor: '#CD081E',
    identity: 'cpay',
    hideLogo: false,
};